<template>
  <div id="login">
    <h2 class="role">Motor Pool IoT</h2>


  </div>
</template>


<script>
import { fb_db, fs, fb_faults, fb_users, fb_auth } from "../firebase";
import router from "../router";


export default {
  name: "RoleLinks",
}



</script>

<style lang="scss" scoped>
#login {
  color: #999999;
}

</style>